/**
 * DatePicker gün bazında seçim yaptırıyor — dönüşen Date objeleri her zaman
 * 00:00:00 local saati ile gelir. Aynı günü hem başlangıç hem bitiş seçtiğinde
 * (örn. tek günlük bir yüz yüze eğitim) iki tarih birbirine eşit olur ve backend
 * tarafında `startDate == endDate` karşılaştırmaları sınıf tarihini geçersiz
 * sayabiliyor. Bu yardımcı:
 *   - Başlangıcı günün 00:00:00.000'ına çeker
 *   - Bitişi günün 23:59:59.999'una çeker
 *   - null değerleri aynen döner
 * Böylece 12 Mayıs → 12 Mayıs gibi tek günlük aralıklar bile 24 saatlik geçerli
 * bir window olarak backend'e gider ve doğrulamalar çalışır.
 */
export function normalizeClassroomDateRange(
  start: Date | null | undefined,
  end: Date | null | undefined,
): { startDateIso?: string; endDateIso?: string } {
  const startCopy = start ? new Date(start) : null;
  const endCopy = end ? new Date(end) : null;
  if (startCopy) startCopy.setHours(0, 0, 0, 0);
  if (endCopy) endCopy.setHours(23, 59, 59, 999);
  return {
    startDateIso: startCopy?.toISOString(),
    endDateIso: endCopy?.toISOString(),
  };
}
